import MediaManager from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    mediaManagers: []
  },
  getters: {
    getCollection: state => state.mediaManagers,
    getById: state => (id) => state.mediaManagers.find(mediaManager => mediaManager.id === id)
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      commit('clearCollection')
      return this.dispatch('get', {
        path: 'v1/mediaManagers',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((mediaManager) => {
            commit('addMediaManagerToCollection', { mediaManagerData: mediaManager })
            return getters.getById(mediaManager.id)
          })

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    }
  },
  mutations: {
    addMediaManagerToCollection(state, { mediaManagerData, opts }) {
      addToCollection(this, state.mediaManagers, mediaManagerData, MediaManager, opts)
    },
    removeMediaManagerFromCollection(state, mediaManagerId) {
      const index = state.mediaManagers.findIndex(el => el.id === mediaManagerId)

      if (index === -1) {
        console.warn(`Could not find/delete mediaManager ${mediaManagerId}`)
        return
      }

      state.mediaManagers.splice(index, 1)
    },
    clearCollection(state) {
      state.mediaManagers = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mediaManager/store.js